const DayTs = 86400 * 1000
export default {
  setItem(key, data, time){
    let saveData = {
      data,
      time: time ? time * DayTs : 0
    }
    localStorage.setItem(key, JSON.stringify(saveData))
  },
  getItem(key){
    let getData = localStorage.getItem(key)
    if(!getData)
      return ''
    try{
      let parseData = JSON.parse(getData);
      let { data, time } = parseData;
      if(!time || 
          parseInt(time) < new Date().getTime())
        return data
      localStorage.removeItem(key)
      return ''
    }catch(e){
      return getData
    }
  },
  removeItem: (key) => localStorage.removeItem(key)
}


// WEBPACK FOOTER //
// ./src/utils/cookies/local.js